import React, { useState } from "react";
import Banner from "../common/Banner";
import faq from "../../data/faq.json";
import images from "../../assets/images/Constant";


function CheckItem({ title, description }) {
  return (
    <div className="flex gap-4">
      <div className="shrink-0 w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M20 6L9 17l-5-5"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div>
        <h4 className="font-semibold text-[#0b2c3d]">{title}</h4>
        <p className="mt-1 text-sm text-[#9CA3AF] leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}

function AccordionRow({ question, answer, open, onToggle }) {
  return (
    <div className="bg-[#F4F4F4] border border-[#EDEDED]">
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between px-6 py-5 text-left"
        aria-expanded={open}
      >
        <span className="font-semibold text-[#0b2c3d] text-sm md:text-base">
          {question}
        </span>
        <span className="text-[#0b2c3d]">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className={`transition-transform ${open ? "rotate-180" : ""}`}
          >
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>

      {open && (
        <div className="px-6 pb-5 -mt-1">
          <p className="text-sm text-[#9CA3AF] leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default function FaqPage() {
  const items = faq?.items || [];
  const left = faq?.left || {};
  const bullets = left?.bullets || [];

  const [openIndex, setOpenIndex] = useState(0);

  return (
    <>
      <Banner
        title={faq?.banner?.title || "Faqs"}
        currentLabel={faq?.banner?.breadcrumb || "Faqs"}
      />

      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <div className="flex gap-2 justify-center ">
      <img src={images[faq.icon]} alt=""  className=""/>
          <span className="text-base md:text-[22px] uppercase tracking-widest font-medium text-primary">
            {faq.rightEyebrow}
          </span>
</div>
        <h1 className="mt-3 text-center text-3xl md:text-[44px] font-semibold text-[#0b2c3d]">
          {faq?.title}
        </h1>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-start pb-10">
          {/* LEFT */}
          <div className="lg:col-span-6">
            <div className="bg-white shadow-[0_10px_30px_rgba(0,0,0,0.08)] overflow-hidden">
              <img
                src={images[left?.image]}
                alt=""
                className="w-full h-[240px] object-cover"
              />
            </div>

            <div className="mt-8 space-y-6">
              {bullets.map((b, i) => (
                <CheckItem
                  key={`${b.title}-${i}`}
                  title={b.title}
                  description={b.description}
                />
              ))}
            </div>
          </div>

          {/* RIGHT */}
          <div className="lg:col-span-6 space-y-4">
            {items.map((it, idx) => (
              <AccordionRow
                key={`${it.question}-${idx}`}
                question={it.question}
                answer={it.answer}
                open={openIndex === idx}
                onToggle={() => setOpenIndex((prev) => (prev === idx ? -1 : idx))}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

